import React from 'react';

import { useRouter } from 'react-resource-router';

import RepositoryRoute from './repository-route';

/* eslint @typescript-eslint/ban-types: "warn" */
const RepositoryLayout: React.FC = ({ children }) => {
  const [router] = useRouter();
  return (
    // @ts-ignore: requires @atlaskit/router to be bumped after AKR-23 released
    <RepositoryRoute {...router}>{children}</RepositoryRoute>
  );
};

export default RepositoryLayout;
